<template>
    <div class="main-container">
        <div class="screenshots">

            <img class="logo" src="../../assets/ChatDiary/today.png" alt="Add Record"/>
            <img class="logo" src="../../assets/ChatDiary/add.png" alt="Logo"/>
            <img class="logo" src="../../assets/ChatDiary/calendar.png" alt="Logo"/>
            <img class="logo" src="../../assets/ChatDiary/empty.png" alt="Logo"/>
        </div>
        <span class="title">Chat Diary</span>
        <span class="desc">Chat to your diary. Simple and Quick.</span>
        <a href=""><img src="../../assets/Drifter/appstore-black.svg" style="margin-top:20px;margin-bottom:20px"></a>
        <span style="font-size:9pt"><router-link to="/chatdiary/privacy">Privacy Policy</router-link></span>
    </div>
</template>

<style scoped>

    .screenshots{
        display:flex;
        flex-direction: row;

    }

    .main-container{
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height:100%;
        width:100%;
    }

    .logo{
        max-width:200px;
        width:80%;
        margin-left:10px;
        margin-right:10px;
        border-radius: 10px;
    }

    .title{
        font-size:20pt;
        font-weight: bold;
    }
</style>

<script>

    export default {
        name: "ChatDiary"
    }

</script>